import DocksComingSoon from './DocksComingSoon';

function App() {
  return <DocksComingSoon />;
}

export default App;
